import React from "react";
import { Row, Column } from "react-foundation";
import { Link } from "react-router-dom";

import Logo from "components/Logo";

const Thanks = () => {
    return (
        <div style={{ position: "relative" }}>
            <Logo topLeft={true} />
            <Row className="top-padding-page">
                <Column small={10} medium={8} large={6} centerOnSmall>
                    <h3>Thank You</h3>
                    <p>We’re in the process of generating your quotes. Please bear with us and expect an email in the next 5 minutes.</p>
                </Column>
            </Row>
            <Link className="button" to="/Item/Selector">
                Add another Product
            </Link>
        </div>
    );
};

export default Thanks;



// WEBPACK FOOTER //
// ./src/containers/AdditionalForm/Thanks.js